import * as React from "react";

import Button from "@material-ui/core/Button";
import { DetailActionProps, getNextPage } from "../detail-actions-props";
import TransferIcon from "@material-ui/icons/TransferWithinAStation";
import LoadingIcon from "@material-ui/icons/Timelapse";
import * as releaseAdmin from "../../../../../sdk/release-admin";
import { useHistory, useLocation } from "react-router";
import { TransferDialog } from '../transfer-dialog';
import { handleReleaseTransferred } from "../../../../../utils/rudderstack/events";

export const TransferRelease: React.FC<DetailActionProps> = (props) => {
  const { data } = props;
  const history = useHistory();
  const location = useLocation<{from?: string}>();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleTransfer = async (userId: string) => {
    setLoading(true);
    setOpen(false);

    await Promise.all(
      data.map(async ({ release, tracks }) => {
        await releaseAdmin.transferRelease(
          release.id,
          userId,
          release.UPCEAN
        );
        
        await handleReleaseTransferred({release, tracks, userId});
      })
    );

    setLoading(false);

    props.onAction(data.map(({ release }) => release.id));
    history.push(getNextPage(location.state?.from), location.state);
  };

  return (
    <>
      <Button
        variant="outlined"
        color="default"
        endIcon={loading ? <LoadingIcon /> : <TransferIcon />}
        onClick={() => setOpen(true)}
      >
        Transfer
      </Button>

      <TransferDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        onSend={handleTransfer}
        title={`Transfer: ${data[0].release.title}`}
      />
    </>
  );
};
